module.exports = __webpack_public_path__ + "static/coffee-1548766_1920_640px-8bd52e6b5087927205e46c6917c4fa6d.jpg";